module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"empty-album-description":"Não há nenhum álbum em seu acervo. Comece criando um pelo menu acima.","empty-album-title":"Acervo vazio","title":"Meus álbuns"}}')
  delete Component.options._Ctor
}
